import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=8918cb38&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=8918cb38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8918cb38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2461170410/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8918cb38')) {
      api.createRecord('8918cb38', component.options)
    } else {
      api.reload('8918cb38', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=8918cb38&scoped=true", function () {
      api.rerender('8918cb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductCard.vue"
export default component.exports